<!-- <div mat-dialog-title>{{ data.title }}</div> -->

<div mat-dialog-content>
  <img src="/api/files/{{ data.fileid }}" style="max-width: 1000px" />
</div>

<!-- <div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>关闭</button>
</div> -->
